export const contentConstants = {
    IMAGES: "IMAGES",
    CONTENT: "CONTENT",
    APP_CONTENT:"APP_CONTENT",
    FOOTER_CONTENT:"FOOTER_CONTENT",
    FAQ:"FAQ",
    ANNOUNCEMENT:"ANNOUNCEMENT",
    LINKS:"LINKS",
    DESKTOP_IMG:"DESKTOP_IMG"
  };
  